/**
 * Дедупликация записей каталога (фидбек 27.07): юнит-здание и точка-арендатор
 * с одним именем, а также POI-двойники на разных уровнях показываются одной
 * строкой. Приоритет — арендатор (кликабельная цель с деталями).
 */
import type { Venue } from '@app/rvf'
import type { SearchEntry } from '../search'
import { featureName } from './labels'

export function dedupeEntries(v: Venue, entries: readonly SearchEntry[]): SearchEntry[] {
  const seen = new Map<string, SearchEntry>()
  const rank = (e: SearchEntry): number => (e.kind === 'tenant' ? 2 : e.kind === 'building' ? 1 : 0)
  for (const e of entries) {
    const key = `${featureName(v, e.id).toLowerCase().trim()}|${e.category}`
    const prev = seen.get(key)
    if (!prev || rank(e) > rank(prev)) seen.set(key, e)
  }
  return [...seen.values()]
}
